import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const InviteHandler: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    
    if (token) {
      // Store token in localStorage - this token must persist through signup
      // and will only be removed after successful login in LoginPage.tsx
      localStorage.setItem('invitation_token', token);
    } else {
      console.warn('No invitation token found in URL');
    }
    
    // Redirect to signup - token should remain in localStorage
    navigate('/signup', { replace: true });
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-engramiq-dark-blue text-engramiq-light-grey">
      <p>Processing invitation...</p>
    </div>
  );
};

export default InviteHandler;

